import React from 'react'

export const ColSettings = () => {

  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
